import { getMapBy } from '../common/utils';
import {
  SystemClassifierCode,
  SystemClassifierDto,
  SystemClassifierItemDto,
} from '../systemClassifier';
import { useSystemClassifiers } from './useSystemClassifiers';

export const useSystemClassifierItemsBy = <
  Codes extends SystemClassifierCode[],
  Key extends keyof SystemClassifierItemDto,
>(
  codes: Codes,
  key?: Key,
): {
  [K in Codes[number]]: Map<
    SystemClassifierItemDto[Key],
    SystemClassifierItemDto
  >;
} => {
  const systemClassifiers = useSystemClassifiers(...codes);

  const entries = Object.entries<SystemClassifierDto>(systemClassifiers).map(
    ([code, systemClassifier]) => [
      code,
      getMapBy(systemClassifier.systemClassifierItems, key || 'id'),
    ],
  );

  return Object.fromEntries(entries);
};
